<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="auto">
          <h6 class="m-0">Dados do Cliente</h6>
        </d-col>
        <d-col>
          <span class="btn btn-success btn-sm ml-4" @click.prevent="toggleMode()">{{ searchCustomer ? 'Adicionar novo cliente' : 'Buscar cliente' }}</span>
        </d-col>
      </d-row>
    </d-card-header>

    <d-card-body class="d-flex flex-column">
     <no-permission v-if="isCustomer" />

      <template v-else>
        <d-form v-if="searchCustomer" @submit="save" class="d-flex flex-fill flex-column">
          <d-form-row>
            <!-- Nome -->
            <d-col md="8" class="form-group autocomplete">
              <label for="name">Selecionar cliente</label>
              <autocomplete
                ref="autocomplete"
                placeholder="Cliente"
                :state="hasErrorFiled('customer_name')"
                :items="custumers"
                item-show="name"
                :on-input="onInput"
                :on-select="setQuotationCustomer"
                :on-show-text="showText"
                clear-input
              ></autocomplete>
              <d-form-invalid-feedback>Cliente é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <div v-if="model.customer_name" class="border-top pb-4"></div>
        </d-form>
      </template>
      <customer-form v-show="model.customer_name || ! searchCustomer" ref="customerForm" :show-project="false" />
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button class="btn btn-success" @click="save">Salvar e avançar</button>
        </d-col>
      </d-form-row>

    </d-card-body>

  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import CustomerForm from '_modules/customer/components/CustomerForm.vue';
import { MODEL, _LOAD_MODEL_ } from '_modules/quotation/components/QuotationModel';
import {
  _SAVE_CUSTOMER_SUCCESS_,
  _LOAD_MODEL_ as _LOAD_MODEL_CUSTOMER_,
  MODEL as MODEL_CUSTOMER,
} from '_modules/customer/components/CustomerModel';
import QuotationService from '_services/rest/modules/quotation';
import NoPermission from './NoPermission.vue';

export default {
  name: 'Step-customer',
  mixins: [MixinValidateForm],
  components: {
    Autocomplete,
    CustomerForm,
    NoPermission,
  },
  data() {
    return {
      searchCustomer: true,
      model: cloneDeep(MODEL),
      loading: false,
    };
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    custumers() {
      const { customerList } = this.$store.state.customer;
      if (customerList && customerList.list.length) {
        return customerList.list;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'getCustomerList',
      'commitCustomer',
    ]),
    getListCustomer(name = '') {
      this.toggleLoading();
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getCustomerList(params)
        .then(() => {
          this.toggleLoading();
        });
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getListCustomer(name);
      }, 500);
    },
    setQuotationCustomer(customer) {
      this.model.customer_id = customer.id;
      this.model.customer_name = customer.name;
      this.setStateCustomer(customer);
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.document}</strong>`;
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    toggleMode() {
      this.searchCustomer = !this.searchCustomer;
      if (this.searchCustomer) {
        return this.setStateCustomer(this.model.customer);
      }
      return this.setStateCustomer({});
    },
    setStateCustomer(customer) {
      customer = { ...MODEL_CUSTOMER, ...customer };
      this.commitCustomer(customer);
      Events.$emit(_LOAD_MODEL_CUSTOMER_, this.$store.state.customer.customer);
    },
    save() {
      this.$refs.customerForm.save();
    },
    saveQuotationCustomer() {
      const { quotation } = this.$store.state.quotation;
      if (quotation && this.model.cutomer_id === quotation.customer_id) {
        return this.$router.push({ name: 'admin-quotation-service', params: { quotationId: this.model.id } });
      }

      const quotationCustomer = {
        id: this.model.id,
        step: 'customer',
        status_id: this.model.statua_id || 1,
        type_id: this.model.type_id,
        customer_id: this.model.customer_id,
        customer_name: this.model.customer_name,
      };
      return QuotationService.save(quotationCustomer)
        .then(response => {
          this.$store.commit('setQuotation', response);
          this.$router.push({ name: 'admin-quotation-service', params: { quotationId: response.id } });
        });
    },
    loadModel() {
      const { quotationId } = this.$route.params;
      if (quotationId === 'novo') {
        this.$store.commit('setQuotation', cloneDeep(MODEL));
        this.model = cloneDeep(MODEL);
        this.model.custumer = cloneDeep(MODEL_CUSTOMER);
      }
      if (this.model.customer) {
        this.setStateCustomer(this.model.customer);
      }
    },
  },
  destroyed() {
    Events.$off(_SAVE_CUSTOMER_SUCCESS_);
    Events.$off(_LOAD_MODEL_);
  },
  mounted() {
    this.model = this.$store.state.quotation.quotation;
    this.loadModel();
    Events.$on(_LOAD_MODEL_, quotation => {
      this.model = quotation;
      this.loadModel();
    });
    Events.$on(_SAVE_CUSTOMER_SUCCESS_, customerSaved => {
      this.setQuotationCustomer(customerSaved);
      this.saveQuotationCustomer();
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
